import { useTranslation } from "react-i18next";
import "./Pillars.css";

const SERVICES = [
  { num: "01", key: "consulting" },
  { num: "02", key: "dev" },
  { num: "03", key: "infra" },
  { num: "04", key: "outsourcing" },
  { num: "05", key: "security" },
  { num: "06", key: "bi" },
];

export default function Pillars() {
  const { t } = useTranslation();
  return (
    <section id="servicos" className="pillars section">
      <div className="container">
        <header className="pillars__header">
          <span className="pillars__eyebrow">{t("pillars.eyebrow")}</span>
          <h2 className="pillars__title">{t("pillars.title")}</h2>
          <p className="pillars__lead">{t("pillars.lead")}</p>
        </header>

        <div className="pillars__grid">
          {SERVICES.map((s) => (
            <article key={s.num} className="pillar">
              <span className="pillar__num">{s.num}</span>
              <h3 className="pillar__title">{t(`pillars.items.${s.key}.title`)}</h3>
              <p className="pillar__body">{t(`pillars.items.${s.key}.body`)}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
